/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualDid: core.serialization.ObjectSchema<serializers.EqualDid.Raw, Truvity.EqualDid> =
    core.serialization.object({
        value: core.serialization.string(),
    });

export declare namespace EqualDid {
    export interface Raw {
        value: string;
    }
}
